var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCrate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dc8758"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c3d27"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 111.549,
    x2: 535.462,
    xlinkHref: "#lg1",
    y1: 255,
    y2: 255
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#904d24",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c3d27"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg2",
    y1: 140.583,
    y2: 546.462
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 380.314,
    x2: 277.348,
    xlinkHref: "#lg2",
    y1: 380.314,
    y2: 277.348
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientTransform: "matrix(.707 -.707 .707 .707 45.343 192.467)",
    gradientUnits: "userSpaceOnUse",
    x1: 104.033,
    x2: 104.033,
    xlinkHref: "#lg1",
    y1: 160.967,
    y2: 254.053
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientTransform: "matrix(.707 -.707 .707 .707 45.343 192.467)",
    gradientUnits: "userSpaceOnUse",
    x1: 104.12,
    x2: 105.148,
    xlinkHref: "#lg2",
    y1: 189.387,
    y2: 141.053
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientTransform: "matrix(.707 -.707 .707 .707 45.343 192.467)",
    gradientUnits: "userSpaceOnUse",
    x1: 104.76,
    x2: 91.76,
    xlinkHref: "#lg2",
    y1: 211.962,
    y2: 124.962
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 140.07,
    x2: 69.001,
    xlinkHref: "#lg2",
    y1: 255,
    y2: 255
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg2",
    y1: 170.581,
    y2: 77.538
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientTransform: "matrix(0 -1 1 0 0 510)",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg1",
    y1: 10,
    y2: 103.086
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientTransform: "matrix(0 -1 1 0 0 510)",
    gradientUnits: "userSpaceOnUse",
    x1: 255.086,
    x2: 256.11,
    xlinkHref: "#lg2",
    y1: 38.479,
    y2: -9.662
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientTransform: "matrix(0 -1 1 0 0 510)",
    gradientUnits: "userSpaceOnUse",
    x1: 255.736,
    x2: 242.979,
    xlinkHref: "#lg2",
    y1: 61.076,
    y2: -24.296
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientTransform: "matrix(0 1 1 0 0 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg1",
    y1: 437,
    y2: 530.086
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientTransform: "matrix(0 1 1 0 0 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 255.086,
    x2: 256.11,
    xlinkHref: "#lg2",
    y1: 465.479,
    y2: 417.338
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientTransform: "matrix(0 1 1 0 0 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 255.736,
    x2: 242.979,
    xlinkHref: "#lg2",
    y1: 488.076,
    y2: 402.704
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg1",
    y1: 10,
    y2: 103.086
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 255.087,
    x2: 256.116,
    xlinkHref: "#lg2",
    y1: 38.42,
    y2: -9.915
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 255.727,
    x2: 242.727,
    xlinkHref: "#lg2",
    y1: 60.995,
    y2: -26.005
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientTransform: "matrix(-1 0 0 1 510 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg1",
    y1: 437,
    y2: 530.086
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientTransform: "matrix(-1 0 0 1 510 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 255.087,
    x2: 256.116,
    xlinkHref: "#lg2",
    y1: 465.42,
    y2: 417.085
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientTransform: "matrix(-1 0 0 1 510 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 255.727,
    x2: 242.727,
    xlinkHref: "#lg2",
    y1: 487.995,
    y2: 400.995
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 70.223,
    x2: 10.671,
    xlinkHref: "#lg1",
    y1: 69.5,
    y2: 9.948
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#537983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e5959"
  }))), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 33.723,
    x2: 44.235,
    xlinkHref: "#lg3",
    y1: 33,
    y2: 43.512
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 495.777,
    x2: 436.224,
    xlinkHref: "#lg1",
    y1: 69.5,
    y2: 9.948
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 459.277,
    x2: 469.789,
    xlinkHref: "#lg3",
    y1: 33,
    y2: 43.512
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 70.223,
    x2: 10.671,
    xlinkHref: "#lg1",
    y1: 496.5,
    y2: 436.948
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 33.723,
    x2: 44.235,
    xlinkHref: "#lg3",
    y1: 460,
    y2: 470.512
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 495.777,
    x2: 436.224,
    xlinkHref: "#lg1",
    y1: 496.5,
    y2: 436.948
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 459.277,
    x2: 469.789,
    xlinkHref: "#lg3",
    y1: 460,
    y2: 470.512
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m66.009 66.009h377.981v377.981h-377.981z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m166.289 66.009h177.422v377.981h-177.422z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m443.99 443.991v-364.341l-364.34 364.341z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m451.092 117.598-333.494 333.494c-7.492 7.492-19.638 7.492-27.13 0l-31.56-31.56c-7.492-7.492-7.492-19.638 0-27.13l333.494-333.494c7.492-7.492 19.638-7.492 27.13 0l31.56 31.56c7.492 7.492 7.492 19.638 0 27.13z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.192 420.817 30.276 30.276c7.492 7.492 19.638 7.492 27.13 0l333.495-333.495c7.492-7.492 7.492-19.638 0-27.13l-30.276-30.276z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.577 439.201 11.891 11.891c7.492 7.492 19.638 7.492 27.13 0l333.495-333.495c7.492-7.492 7.492-19.638 0-27.13l-11.891-11.891z",
    fill: "url(#SVGID_6_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m66.01 66.01h100.28v377.98h-100.28z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.01 66.009h377.981v116.571h-377.981z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m83 26.005v457.991c0 10.446-8.469 18.915-18.915 18.915h-45.17c-10.446-.001-18.915-8.469-18.915-18.916v-457.99c0-10.447 8.469-18.915 18.915-18.915h45.17c10.446 0 18.915 8.468 18.915 18.915z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21 502.91h42.816c10.595 0 19.184-8.35 19.184-18.65v-458.52c0-10.3-8.589-18.65-19.184-18.65h-42.816z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47 502.91h16.816c10.595 0 19.184-8.35 19.184-18.65v-458.52c0-10.3-8.589-18.65-19.184-18.65h-16.816z",
    fill: "url(#SVGID_11_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m510 483.995v-457.99c0-10.446-8.469-18.915-18.915-18.915h-45.17c-10.446 0-18.915 8.468-18.915 18.915v457.991c0 10.446 8.469 18.915 18.915 18.915h45.17c10.446-.001 18.915-8.469 18.915-18.916z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m448 7.09h42.816c10.595 0 19.184 8.35 19.184 18.65v458.52c0 10.3-8.589 18.65-19.184 18.65h-42.816z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m474 7.09h16.816c10.595 0 19.184 8.35 19.184 18.65v458.52c0 10.3-8.589 18.65-19.184 18.65h-16.816z",
    fill: "url(#SVGID_14_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m490.816 83h-471.632c-10.595 0-19.184-8.589-19.184-19.184v-44.632c0-10.595 8.589-19.184 19.184-19.184h471.633c10.594 0 19.183 8.589 19.183 19.184v44.633c0 10.594-8.589 19.183-19.184 19.183z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 21v42.816c0 10.595 8.589 19.184 19.184 19.184h471.633c10.594 0 19.183-8.589 19.183-19.184v-42.816z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 47v16.816c0 10.595 8.589 19.184 19.184 19.184h471.633c10.594 0 19.183-8.589 19.183-19.184v-16.816z",
    fill: "url(#SVGID_17_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m19.184 510h471.633c10.595 0 19.184-8.589 19.184-19.184v-44.633c0-10.595-8.589-19.184-19.184-19.184h-471.633c-10.595.001-19.184 8.59-19.184 19.185v44.633c0 10.594 8.589 19.183 19.184 19.183z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m510 448v42.816c0 10.595-8.589 19.184-19.184 19.184h-471.632c-10.595 0-19.184-8.589-19.184-19.184v-42.816z",
    fill: "url(#SVGID_19_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m510 474v16.816c0 10.595-8.589 19.184-19.184 19.184h-471.632c-10.595 0-19.184-8.589-19.184-19.184v-16.816z",
    fill: "url(#SVGID_20_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 42.223,
    cy: 41.5,
    fill: "url(#SVGID_21_)",
    r: 20
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.223,
    cy: 41.5,
    fill: "url(#SVGID_22_)",
    r: 13.449
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 467.777,
    cy: 41.5,
    fill: "url(#SVGID_23_)",
    r: 20
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 467.777,
    cy: 41.5,
    fill: "url(#SVGID_24_)",
    r: 13.449
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 42.223,
    cy: 468.5,
    fill: "url(#SVGID_25_)",
    r: 20
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.223,
    cy: 468.5,
    fill: "url(#SVGID_26_)",
    r: 13.449
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 467.777,
    cy: 468.5,
    fill: "url(#SVGID_27_)",
    r: 20
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 467.777,
    cy: 468.5,
    fill: "url(#SVGID_28_)",
    r: 13.449
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCrate);
export default __webpack_public_path__ + "static/media/icon-crate.6a5594e9b44700f137e0bba983cbca3d.svg";
export { ForwardRef as ReactComponent };